import type { Context } from "../context.js";
import type { EmitFn } from "../adapters.js";

/**
 * Quizzes (OPCIONALES — solo si el blog los tiene). Convención por atributos:
 *   <div data-tw-quiz="quizId"> ... <button data-tw-quiz-answer="valor">…</button> </div>
 * Las respuestas alimentan ctx.quizAnswer[quizId] y son señal para las reglas.
 */
export function startQuiz(ctx: Context, emit: EmitFn) {
  // Delegación: escuchamos siempre, también para quizzes INYECTADOS más tarde
  // (p. ej. el bloque de Quiz nativo que añade una regla).
  const started = new Set<string>();

  document.addEventListener(
    "click",
    (e) => {
      const t = e.target instanceof Element ? e.target : null;
      const opt = t?.closest<HTMLElement>("[data-tw-quiz-answer]");
      if (!opt) return;
      const container = opt.closest<HTMLElement>("[data-tw-quiz]");
      if (!container) return;
      const quizId = container.getAttribute("data-tw-quiz") || "quiz";
      const answer = opt.getAttribute("data-tw-quiz-answer") || "";

      if (!started.has(quizId)) {
        started.add(quizId);
        emit("quiz_start", { quizId });
      }

      ctx.state.quizAnswer[quizId] = answer;
      ctx.state.quizCompleted = true;
      emit("quiz_answer", { quizId, answer });
      emit("quiz_complete", { quizId, answer });
      ctx.touch();
    },
    { passive: true }
  );
}
